export class TabNavLinks {
  id: number;
  label: string;
  path: any;

  constructor(id: number, label: string, path: any) {
    this.id = id;
    this.label = label;
    this.path = path;
  }
}
